import { render, staticRenderFns } from "./PersonificationSkeleton.vue?vue&type=template&id=6bf4c232&"
var script = {}
import style0 from "./personification-skeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports